import type { IFIXParser, Message } from 'fixparser';

import type { MarketDataEntry, ToolHandlers, VerifiedOrder } from '../schemas';
import { createTechnicalAnalysisHandler } from './analytics';
import {
    createGetStockGraphHandler,
    createGetStockPriceHistoryHandler,
    createMarketDataRequestHandler,
} from './marketData';
import { createExecuteOrderHandler, createVerifyOrderHandler } from './order';
import { createParseHandler } from './parse';
import { createParseToJSONHandler } from './parseToJSON';

export const createToolHandlers = (
    parser: IFIXParser,
    verifiedOrders: Map<string, VerifiedOrder>,
    pendingRequests: Map<string, (data: Message) => void>,
    marketDataPrices: Map<string, MarketDataEntry[]>,
): ToolHandlers => ({
    parse: createParseHandler(parser),
    parseToJSON: createParseToJSONHandler(parser),
    verifyOrder: createVerifyOrderHandler(parser, verifiedOrders),
    executeOrder: createExecuteOrderHandler(parser, verifiedOrders, pendingRequests),
    marketDataRequest: createMarketDataRequestHandler(parser, pendingRequests),
    getStockGraph: createGetStockGraphHandler(marketDataPrices),
    getStockPriceHistory: createGetStockPriceHistoryHandler(marketDataPrices),
    technicalAnalysis: createTechnicalAnalysisHandler(marketDataPrices),
});
